module.exports = __webpack_public_path__ + "img/64.e17ea575.jpg";